const REFACTOR_ELEMENTS = [Object.freeze({
  id: 'om',
  factorId: 'om',
  name: '有机物',
  factorIds: ['6400'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(0, 176, 80)'
}), Object.freeze({
  id: 'sulfate',
  factorId: 'sulfate',
  name: '硫酸盐',
  factorIds: ['6104'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(255, 0, 0)'
}), Object.freeze({
  id: 'nitrate',
  factorId: 'nitrate',
  name: '硝酸盐',
  factorIds: ['6103'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(0, 112, 192)'
}), Object.freeze({
  id: 'ammoniumSalt',
  factorId: 'ammoniumSalt',
  name: '铵盐',
  factorIds: ['6108'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(255, 192, 0)'
}), Object.freeze({
  id: 'elementalCarbon',
  factorId: 'elementalCarbon',
  name: '元素碳',
  factorIds: ['6401'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(0, 0, 0)'
}), Object.freeze({
  id: 'chlorineSalt',
  factorId: 'chlorineSalt',
  name: '氯盐',
  factorIds: ['6101'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(255, 51, 204)'
}), Object.freeze({
  id: 'crustalMaterial',
  factorId: 'crustalMaterial',
  name: '地壳物质',
  factorIds: ['3000', '3001', '3011', '3040', '6111'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(165, 232, 241)'
}), Object.freeze({
  id: 'traceElement',
  factorId: 'traceElement',
  name: '微量元素',
  factorIds: ['6109', '6110', '6100', '3033', '3029', '3030', '3008', '3009', '3010', '3012', '3013', '3014', '3015', '3018', '3019', '3041', '3032', '3002', '6107'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(129, 102, 162)'
}), Object.freeze({
  id: 'qualityRatio',
  factorId: 'qualityRatio',
  name: '质量浓度比值',
  factorIds: [],
  stdUnit: '',
  displayUnit: '',
  color: 'rgb(0, 176, 80)'
}), Object.freeze({
  id: 'pm25',
  factorId: 'pm25',
  name: 'PM2.5',
  factorIds: ['1008'],
  stdUnit: 'μg/m3',
  displayUnit: 'μg/m3',
  color: 'rgb(0, 176, 80)'
})]

const REFACTOR_ELEMENT_MAP = REFACTOR_ELEMENTS.reduce((map, REFACTOR_ELEMENT) => {
  map[REFACTOR_ELEMENT.id] = REFACTOR_ELEMENT
  return map
}, {})

const REFACTOR_FACTOR_ID_MAP = REFACTOR_ELEMENTS.reduce((map, REFACTOR_ELEMENT) => {
  let refactorElementId = REFACTOR_ELEMENT.id

  return REFACTOR_ELEMENT.factorIds.reduce((map, factorId) => {
    map[factorId] = refactorElementId
    return map
  }, map)
}, {})

export default class PM25QualityRefactor {
  static REFACTOR_ELEMENTS = REFACTOR_ELEMENTS

  static REFACTOR_ELEMENT_MAP = REFACTOR_ELEMENT_MAP

  static REFACTOR_FACTOR_ID_MAP = REFACTOR_FACTOR_ID_MAP
}



// WEBPACK FOOTER //
// ./src/model/PM25QualityRefactor.js